import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

interface InventoryHeaderProps {
  title: string;
  addLabel: string;
  onAdd: () => void;
}

const InventoryHeader: React.FC<InventoryHeaderProps> = ({ title, addLabel, onAdd }) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={() => navigate(-1)}
        className="text-gray-600 hover:text-gray-800"
      >
        <span className="w-5 h-5 text-gray-700">{FaArrowLeft({})}</span>
      </button>
      <h1 className="text-2xl font-bold">{title}</h1>
      <div className="ml-auto">
        <button
          onClick={onAdd}
          className="bg-blue-600 text-sm semi-bold text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
        >
          + {addLabel}
        </button>
      </div>
    </div>
  );
};

export default InventoryHeader;
